"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.impossibleEmailSchema = void 0;
const zod_1 = require("zod");
const EmailValidator = require("email-validator");
exports.impossibleEmailSchema = zod_1.z.string().email().refine((value) => EmailValidator.validate(value));
